<template>
  <div class="custom-recommend">
    <div class="section">
      <p class="title">性别（单选）</p>
      <span
        class="section-item"
        :class="{ active: form.sex == item }"
        v-for="item in sexList"
        :key="item"
        @click="form.sex = item"
        >{{ item }}</span
      >
    </div>

    <div class="section">
      <p class="title">年龄（多选）</p>
      <span
        class="section-item"
        :class="{ active: form.age.length == 0 }"
        @click="form.age = []"
        >不限</span
      >
      <span
        class="section-item"
        :class="{ active: isInArray(form.age, item) }"
        v-for="item in ageList"
        :key="item"
        @click="handleChoose(item, 'age')"
        >{{ item }}</span
      >
    </div>

    <div class="section">
      <p class="title">地域（单选）</p>
      <span
        class="section-item"
        :class="{ active: form.address.length == 0 }"
        @click="
          form.address = [];
          citys = $options.data().citys;
        "
        >全国</span
      >
      <span
        class="section-item"
        :class="{ active: address == a && form.address.length != 0 }"
        v-for="a in addressList"
        :key="a"
        @click="handleClickCity(a)"
        >{{ a }}<van-icon name="arrow" size="12"
      /></span>

      <div class="interst-tips" v-show="form.address.length > 0">
        <p :class="{ all: showMoreAddress }">
          已选<span class="num">{{ form.address.length }}个</span>地域:
          <span class="interst-item" v-for="i in form.address" :key="i">{{
            i
          }}</span>
        </p>
        <van-icon
          class="icon"
          :name="showMoreAddress ? 'arrow-up' : 'arrow-down'"
          @click="showMoreAddress = !showMoreAddress"
        />
      </div>
    </div>

    <div class="section">
      <p class="title">兴趣标签</p>
      <span
        class="section-item"
        :class="{ active: form.interest.length == 0 }"
        @click="
          form.interest = [];
          interestItems = $options.data().interestItems;
          more = false;
        "
        >不限</span
      >
      <span
        class="section-item"
        :class="{ active: isInArray(form.interest, item) }"
        v-for="item in interestList"
        :key="item"
        @click="handleChoose(item, 'interest')"
        >{{ item }}</span
      >
      <span
        class="section-item"
        :class="{ active: more }"
        @click="showInterst = true"
        >更多<van-icon name="arrow" size="12"
      /></span>

      <div class="interst-tips" v-show="form.interest.length > 0">
        <p :class="{ all: showMoreInterest }">
          已选<span class="num">{{ form.interest.length }}个</span>兴趣:
          <span class="interst-item" v-for="i in form.interest" :key="i">{{
            i
          }}</span>
        </p>
        <van-icon
          class="icon"
          :name="showMoreInterest ? 'arrow-up' : 'arrow-down'"
          @click="showMoreInterest = !showMoreInterest"
        />
      </div>
    </div>

    <div class="section">
      <p class="title">达人相似粉丝</p>
      <span
        class="section-item"
        :class="{ active: form.talent == '不限' }"
        @click="form.talent = '不限'"
        >不限</span
      >
      <span class="section-item">更多<van-icon name="arrow" size="12" /></span>
    </div>

    <van-popup
      v-model="showInterst"
      round
      position="bottom"
      :close-on-click-overlay="false"
    >
      <selecter
        :items="interestItems"
        title="选择兴趣标签"
        @confirm="handleInsterst"
      />
    </van-popup>

    <van-popup
      v-model="showCitys"
      round
      position="bottom"
      :close-on-click-overlay="false"
    >
      <selecter :items="citys" title="按省市选择" @confirm="handleAddress" />
    </van-popup>

    <van-popup
      v-model="showCounty"
      round
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '80vw', overflow: 'hidden' }"
    >
      <treeSelecter
        :tree="cityPca"
        title="按区县选择"
        @cancel="showCounty = false"
        @confirm="handleCounty"
      />
    </van-popup>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { Icon, Popup, Checkbox, Dialog } from "vant";
import selecter from "./components/selecter.vue";
import treeSelecter from "./components/treeSelecter.vue";
import city from "@/utils/city";

export default {
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    selecter,
    treeSelecter,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      sexList: ["不限", "男", "女"],
      ageList: ["18-23岁", "24-30岁", "31-40岁", "41-50岁"],
      interestList: [
        "生活日用",
        "装修设计",
        "箱包",
        "鞋靴",
        "酒水",
        "服饰",
        "社交",
      ],
      addressList: ["按省市", "按区县"],
      address: "",
      showInterst: false,
      interestItems: [
        {
          id: 0,
          text: "教育",
          allChecked: false,
          selectedArr: [],
          children: [
            "早教学前",
            "中小教育",
            "职业教育",
            "学历教育",
            "语言培训",
            "出国留学",
          ],
        },
        {
          id: 1,
          text: "交通",
          allChecked: false,
          selectedArr: [],
          children: [
            "交通其他",
            "摩托车",
            "自行车",
            "电动车",
            "二手汽车",
            "汽车租赁",
            "汽车用品",
            "汽车服务",
            "汽车",
          ],
        },
        {
          id: 2,
          text: "母婴",
          allChecked: false,
          selectedArr: [],
          children: [
            "营养辅食",
            "童车童床",
            "奶粉",
            "尿裤湿巾",
            "婴儿寝居",
            "童鞋",
            "儿童玩具",
            "妈妈专区",
            "安全座椅",
            "喂养用品",
            "童装",
            "洗护用品",
          ],
        },
        {
          id: 3,
          text: "金融",
          allChecked: false,
          selectedArr: [],
          children: ["银行", "证券", "保险", "信托", "海外资产", "互金"],
        },
        {
          id: 4,
          text: "美妆",
          allChecked: false,
          selectedArr: [],
          children: [
            "护肤护理",
            "美妆",
            "口腔护理",
            "洗发护发",
            "美发造型",
            "整形",
            "减肥瘦身",
          ],
        },
        {
          id: 5,
          text: "家电数码",
          allChecked: false,
          selectedArr: [],
          children: [
            "个护电器",
            "厨卫家电",
            "商用家电",
            "大家电",
            "客厅家电",
            "生活家电",
          ],
        },
        {
          id: 6,
          text: "手机电脑",
          allChecked: false,
          selectedArr: [],
          children: [
            "手机",
            "游戏设备",
            "电脑维修",
            "电脑安装",
            "电脑配件",
            "办公设备",
            "电脑整机",
            "网络产品",
            "外设产品",
          ],
        },
        {
          id: 7,
          text: "小说动漫",
          allChecked: false,
          selectedArr: [],
          children: [
            "奇幻玄幻",
            "武侠仙侠",
            "历史军事",
            "都市社会",
            "科幻灵异",
            "游戏竞技",
            "言情小说",
            "文学小说",
            "教育",
          ],
        },
      ],
      more: false,
      showMoreInterest: false,
      showCitys: false,
      citys: JSON.parse(JSON.stringify(city.citySel)),
      showMoreAddress: false,
      showCounty: false,
      cityPca: JSON.parse(JSON.stringify(city.cityPca)),
    };
  },
  methods: {
    // 判断是否已存在在数组中
    isInArray(arr, item) {
      return arr.some((e) => e === item);
    },
    handleChoose(item, str) {
      if (this.isInArray(this.form[str], item)) {
        let index = this.form[str].indexOf(item);
        this.form[str].splice(index, 1);
      } else {
        this.form[str].push(item);
      }
    },
    handleInsterst(val) {
      this.showInterst = false;
      this.form.interest = val;
      this.more = val.length == 0 ? false : true;
    },
    handleClickCity(item) {
      if (this.form.address.length > 0 && item != this.address) {
        Dialog.confirm({
          width: 275,
          message: "更改地域选项后，已选地域会给清空，确定修改吗？",
        })
          .then(() => {
            this.form.address = [];
            this.citys = this.$options.data().citys;
            this.address = item;
            if (item == "按省市") this.showCitys = true;
            else if (item == "按区县") this.showCounty = true;
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.address = item;
        if (item == "按省市") this.showCitys = true;
        else if (item == "按区县") this.showCounty = true;
      }
    },
    handleAddress(val) {
      this.showCitys = false;
      this.form.address = val;
    },
    handleCounty(val) {
      this.form.address = val;
      this.showCounty = false;
    },
  },
};
</script>

<style lang="less" scoped>
.custom-recommend {
  .section {
    padding-left: 10px;
    margin-bottom: 10px;
    .title {
      margin-bottom: 5px;
      color: #909399;
    }
    .section-item {
      display: inline-block;
      padding: 3px 0;
      margin: 5px;
      width: 30%;
      text-align: center;
      color: #303133;
      border: solid 1px #ebeef5;
      border-radius: 3px;
      cursor: pointer;
      &.active {
        color: #ec345c;
        background-color: rgb(255, 230, 235);
        border-color: rgb(255, 215, 223);
      }
    }
    .interst-tips {
      position: relative;
      margin-left: 5px;
      margin-top: 5px;
      color: #909399;
      p {
        width: 95%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.all {
          overflow: inherit;
          white-space: normal;
          text-overflow: inherit;
        }
        .num {
          color: #ec345c;
        }
        .interst-item {
          margin: 0 3px;
        }
      }

      .icon {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>